module.exports = __webpack_public_path__ + "static/banner-image-f7514d359bb9dd4ecf5efea76e916fb7.png";